// Importing necessary assets
import image from "../../../img/7OHMVp.jpg";
import image2 from "../../../img/7OHMVp1.jpg";

// Defining styles for the login page
const signupPageStyle = theme => ({
  // Container styles
  container: {
    display: "flex", // Flexbox layout
    color: "#FFFFFF", // White text color
    width: "100%", // Full width
    height: "98vh", // Full height
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
    backgroundImage: `url(${image})`, // Background image
  },
  // Modal styles
  modal: {
    display: "flex", // Flexbox layout
    alignItems: "center", // Center alignment
    justifyContent: "center", // Center justification
  },
  // Alternate container styles
  container1: {
    display: "flex", // Flexbox layout
    color: "#FFFFFF", // White text color
    width: "100%", // Full width
    height: "100vh", // Full height
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
    backgroundImage: `url(${image2})`, // Background image
  },
  // Button styles
  buttonStyle: {
    backgroundColor: theme.palette.primary.main, // Primary background color
    width: "50%", // Button width
  },
  // Modal card styles
  modalCard: {
    width: "30%", // Card width
    display: "flex", // Flexbox layout
    flexDirection: "column", // Column layout
    flexWrap: "nowrap", // No wrapping
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
    height: "316px", // Fixed height
  },
  // Card container styles
  cardDiv: {
    display: "flex", // Flexbox layout
    flexDirection: "column", // Column layout
    flexWrap: "nowrap", // No wrapping
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
    padding: "30px", // Padding
    textAlign: "center", // Centered text
  },
  // Modal container styles
  modalDiv: {
    display: "flex", // Flexbox layout
    flexDirection: "row", // Row layout
    flexWrap: "nowrap", // No wrapping
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
    alignContent: "stretch", // Stretch alignment
  },
  // Hidden card styles
  cardHidden: {
    opacity: "0", // Hidden
    transform: "translate3d(0, -60px, 0)", // Translate effect
  },
  // Root container styles
  root: {
    display: "flex", // Flexbox layout
    justifyContent: "center", // Center justification
    flexDirection: "column", // Column layout
    alignItems: "center", // Center alignment
    textAlign: "center", // Centered text
  },
  // Forget password styles
  forgetPassword: {
    display: "flex", // Flexbox layout
    alignItems: "flex-end", // Align to the bottom
    justifyContent: "flex-end", // Align to the right
  },
  // User login styles
  userLogin: {
    display: "flex", // Flexbox layout
    alignItems: "flex-end", // Align to the bottom
    justifyContent: "flex-start", // Align to the left
  },
  // Logo styles
  logo: {
    objectFit: "contain", // Contain within bounds
    maxHeight: "250px", // Maximum height
    maxWidth: "250px", // Maximum width
  },
  // Text color styles
  textColor: {
    color: "#00a9a9", // Custom color
  },
  // Card styles
  card: {
    width: "55%", // Card width
    boxShadow: "0 50px 50px 0 rgba(0,0,0,0.7)", // Box shadow
  },
  // Alternate card styles
  card1: {
    width: "65%", // Card width
    boxShadow: "0 50px 50px 0 rgba(0,0,0,0.7)", // Box shadow
  },
  // Page header styles
  pageHeader: {
    minHeight: "100vh", // Minimum height
    color: theme.palette.primary.contrastText, // Contrast text color
    height: "auto", // Auto height
    display: "inherit", // Inherit display
    position: "relative", // Relative positioning
    margin: "0", // No margin
    padding: "0", // No padding
    border: "0", // No border
    alignItems: "center", // Center alignment
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
    },
    "&:before,&:after": {
      position: "absolute", // Absolute positioning
      zIndex: "1", // Z-index
      width: "100%", // Full width
      height: "100%", // Full height
      display: "block", // Block display
      left: "0", // Left position
      top: "0", // Top position
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF", // White text color
    },
    "& footer": {
      position: "absolute", // Absolute positioning
      bottom: "0", // Bottom position
      width: "100%", // Full width
    },
  },
  // Form styles
  form: {
    display: "flex", // Flexbox layout
    flexDirection: "column", // Column layout
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
  },
  // Card header styles
  cardHeader: {
    width: "80%", // Header width
    textAlign: "center", // Centered text
    marginLeft: "20px", // Left margin
    marginRight: "20px", // Right margin
    marginTop: "-40px", // Top margin
    padding: "20px 0", // Padding
    marginBottom: "15px", // Bottom margin
  },
  // Social icons styles
  socialIcons: {
    maxWidth: "24px", // Maximum width
    marginTop: "0", // No top margin
    width: "100%", // Full width
    transform: "none", // No transformation
    left: "0", // Left position
    top: "0", // Top position
    height: "100%", // Full height
    lineHeight: "41px", // Line height
    fontSize: "20px", // Font size
  },
  // Divider styles
  divider: {
    marginTop: "30px", // Top margin
    marginBottom: "0px", // Bottom margin
    textAlign: "center", // Centered text
  },
  // Card footer styles
  cardFooter: {
    paddingTop: "0rem", // Top padding
    border: "0", // No border
    borderRadius: "6px", // Rounded corners
    justifyContent: "center !important", // Center justification
  },
  // Social line styles
  socialLine: {
    marginTop: "1rem", // Top margin
    textAlign: "center", // Centered text
    padding: "0", // No padding
  },
  // Input icon color styles
  inputIconsColor: {
    color: "#495057", // Custom color
  },
});

export default signupPageStyle;
